import { IOneMessageJson, Role } from "../../../../../nodeserver/structs/database.js";
import RefObject = JSX.RefObject;
import JSX from "./../../helpers/react.js";
import { createElementFromHTML } from "../../helpers/functions.js";
import { UserMessageActions, UserMessageActionsDetails, hideAllActions, showMessageUserActions } from "./user-actions.js";

import { canChangeOrSeeMessage, disappearingElement} from "../../messages/helpers.js";
import { UserReportingMessageElement } from "./actions/report.js";
import {linkify, linkifyHTML} from "../../helpers/autolinker.js";

export function Message(props: {
    msg: IOneMessageJson,
    classes: string[]
}) : HTMLElement{

    const msg = props.msg;
    const classes = props.classes;
    const canChangeOrSee = canChangeOrSeeMessage(msg.from_id);
    if (!canChangeOrSee && msg.deleted) return (<></>)
    const object: RefObject<HTMLDivElement> = {};
    return (
        <div className={classes}
            ref={object}
            data-answer-to-id={msg.answer_to_id}
            data-msg={JSON.stringify(msg)}
            data-id={msg.id}
            data-nickname={msg.nickname}
            data-chat-id={msg.to_id}
            onMouseEnter={() => showMessageUserActions(object.value!)}
            onMouseLeave={() => hideAllActions(object.value!)}
        >
            <a href={`/users/id${msg.from_id}`} className="dialog-img bordered">
                <img src={msg.avatars.small} loading="lazy" alt="" className="bordered"/>
            </a>
            <div className="message-data">
                <AnswerToMessage msg={msg}/>
                <UserMessageActions msg={msg} message={object}/>
                <UserMessageActionsDetails msg={msg} message={object}/>
                <TopMsgElement msg={msg}/>
                <UserReportingMessageElement message={object}/>
                <MessageText edited={msg.edited} text={msg.text}/>
            </div>
        </div>
    );

}



export function showMessageText(message: HTMLDivElement) {
    let messageTextElement = $(message).find(".message-text");
    messageTextElement.removeClass(disappearingElement);
}




export function hideMessageText(message: HTMLDivElement) {

    let messageTextElement = $(message).find(".message-text");
    messageTextElement.addClass(disappearingElement);
}

export function MessageText(props: {
    text: string,
    edited: boolean
}) {
    const editedSign = props.edited ? (<span className="edited-text">{"(Ред.)"}</span>) : "";
    return (
        <div className="message-text">
            {
                createElementFromHTML(linkifyHTML(escapeHtml(props.text ?? "")))
            }
            {editedSign}
        </div>
    )
}


export function AnswerToMessage(props: {
    msg: IOneMessageJson
}) {
    const msg = props.msg;

    if (!msg.user_to_answer?.nickname || !msg.user_to_answer?.id)
        return <></>;
    const buildedAnswer : HTMLElement = <div className="message-answer-section">
        <div className="answer-line">
            <img src="/img/answer-line.svg" className="answer-line-img"/>
        </div>
        <div className="answer-user-img">
            <img src={msg.user_to_answer.avatars!.small} loading="lazy" alt="" className="bordered">
                <a href={`/users/id${msg.user_to_answer.id!}`}>
                    
                </a>
            </img>
        </div>
        <div className="answer-user-nickname">
            <a href={`/users/id${msg.user_to_answer.id}`}>
                @{msg.user_to_answer.nickname}
            </a>
        </div>
        <div className="answer-user-text">
            :&nbsp;{msg.message_to_answer!}
        </div>
    </div>
    return buildedAnswer;
}


export function TopMsgElement(props: {
    msg: IOneMessageJson
}) {

    const msg = props.msg;
    return (
        <div className="top-msg">
            <NickName roles={msg.roles ?? []} nickname={msg.nickname} userId={msg.from_id} toId={msg.to_id}/>
            <local-time className="message-date" data-time={msg.date}/>
        </div>
    )
}

export function NickName(props: { roles: Role[], userId: number, nickname: string; toId: number }) {
    let classes: string = "dialog-nickname label";
    const styles: any = {};
    if (props.toId <= 0 && (['root', 'admin', 'chatadmin'] as Role[]).some(e => props.roles?.includes(e))) {
        classes += ' admin';
        if (props.roles!.includes('root'))
            styles['--text'] = '"владелец"';
        if (props.roles!.includes('admin'))
            styles['--text'] = '"админ"';
        else if (props.roles!.includes('chatadmin'))
            styles['--text'] = '"модер"';
    }

    return (
        <a href={`/users/id${props.userId}`} className={classes} style={styles} roles={props.roles.join(" ")}>
            {props.nickname}
        </a>
    )
}

